import PropTypes from 'prop-types';
import Trans from 'next-translate/Trans';

// Components
import InfoBanner from '@/components/base/InfoBanner';
import LinkBase from '@/components/base/LinkBase';

// Routes
import { PLATFORM_OPTIONS } from '@/lib/routes/privateRoutes';

const AwsTranslateSameLanguageBanner = ({
    onClose = () => {
        /** */
    },
    className
}) => (
    <InfoBanner type="info" onClose={onClose} className={className}>
        <Trans
            i18nKey="commons:aws_translate.same_language_banner"
            components={{
                link: <LinkBase href={PLATFORM_OPTIONS} className="font-GSemiBold underline" />
            }}
        />
    </InfoBanner>
);

AwsTranslateSameLanguageBanner.propTypes = {
    onClose: PropTypes.func,
    className: PropTypes.string
};

export default AwsTranslateSameLanguageBanner;
